import { logoText } from "@fuse/sharedComponents/legacyUI/Top/styles"
import FancyText from "@fuse/sharedComponents/typography/FancyText"

import { Colors } from "@fuse/styles/color"

export default function Bottom() {
  return (
    <div className="md:mt-[78] mt-[50px] mx-[30px] md:mx-[50px] lg:mx-[100px] xl:mx-[200px]">
      <div className="flex flex-1 justify-between items-center mb-[43px] md:mb-[80px]">
        <FancyText className="text-[24px]" style={logoText}>
          Let's Hang!
        </FancyText>
      </div>
    </div>
  )
}
